import React from 'react';
import { Option } from '../CustomDropdown';
import { BaseSelector, BaseSelectorProps } from '../BaseSelector';

export type GenericQuestionTypeSelectorProps = Omit<
  BaseSelectorProps,
  'label' | 'options'
>;

export const QUESTION_TYPES: Option[] = [
  // mcq
  { label: 'Multiple Choice', value: 'mcq' },
  { label: 'Multiple Choice - Multiple Responses', value: 'mrq' },
  { label: 'True/False', value: 'mcq-tf' },

  // match
  { label: 'Match List', value: 'association' },
  { label: 'Classification', value: 'classification' },
  { label: 'Order List', value: 'orderlist' },
  { label: 'Choice Matrix', value: 'choicematrix' },

  // cloze
  { label: 'Fill in the Blanks - Text', value: 'clozetext' },
  { label: 'Fill in the Blanks - Drop Down', value: 'clozedropdown' },
  { label: 'Fill in the Blanks - Drag & Drop', value: 'clozeassociation' },
  { label: 'Label Image', value: 'imageclozeassociationV2' },

  // highlight
  { label: 'Highlight Text', value: 'highlight' },
  { label: 'Token Highlight', value: 'tokenhighlight' },
  { label: 'Hotspot', value: 'hotspot' },

  // math
  { label: 'Math', value: 'clozeformulaV2' },
  { label: 'Multi-Step Math', value: 'multistepmath' },
  { label: 'Fill in the Blanks - Math', value: 'clozeformula' },
  { label: 'Gridded', value: 'gridded' },

  // graph
  { label: 'Graph', value: 'graphplotting' },
  { label: 'Number Line - Drag & Drop', value: 'numberline' },
  { label: 'Number Line - Plot', value: 'numberlineplot' },

  // chart
  { label: 'Chart', value: 'simplechart' },

  // writespeak
  { label: 'Short Answer', value: 'shorttext' },

  // chemistry
  { label: 'Chemistry Formula', value: 'chemistry' },
  { label: 'Fill in the Blanks - Chemistry', value: 'clozechemistry' },
  { label: 'Fill in the Blanks - Chemistry Image', value: 'imageclozechemistry' },

  // other
  { label: 'Shading', value: 'simpleshading' },
  { label: 'Image annotation', value: 'imageupload' },
];

export const GenericQuestionTypeSelector: React.FC<GenericQuestionTypeSelectorProps> = (
  props,
) => <BaseSelector {...props} label="Question Type" options={QUESTION_TYPES} />;

// TODO: Remove this component prefix once we remove the old question type selector
export default GenericQuestionTypeSelector;
